import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class AddCompanyReference {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(company_id,item): Promise<any> {
    let args = { 
        company_id: company_id,
        item: item
    }
    return await this.dispatcher.dispatch('add.company.reference', args)
  }
}